import { OptimizelyProvider } from '@optimizely/react-sdk';
import { FC, ReactNode } from 'react';

import Client from '../services/feature-flags';
import { useAuth } from './Authentication.context';

function addIf<T>(name: string, condition: boolean, obj: T): Record<string, T> {
	if (condition) {
		return { [name]: obj };
	}
	return {};
}

function addIfDefined<T>(name: string, obj: T | undefined): Record<string, T> {
	return obj !== undefined ? addIf(name, true, obj) : {};
}

export const FeatureFlagsProvider: FC<{ children?: ReactNode }> = ({ children }) => {
	const user = useAuth();

	return (
		<OptimizelyProvider
			optimizely={Client}
			user={{
				id: user?.id || 'test',
				attributes: {
					...addIfDefined('isInBetaProgram', user?.workspace.isInBetaProgram),
					...addIfDefined('userId', user?.id),
					...addIfDefined('organisationId', user?.organisationId),
					...addIfDefined('workspaceId', user?.workspace.id),
					...addIfDefined('subscriptionKind', user?.subscription?.kind),
					...addIfDefined('subscriptionPlanFamily', user?.subscription?.plan?.family),
					...addIfDefined('subscriptionPlanGroup', user?.subscription?.plan?.groupKey),
					creationDateInMillis: user?.workspace.signedUpAt ? user.workspace.signedUpAt.toMillis() : null,
				},
			}}
		>
			{children}
		</OptimizelyProvider>
	);
};
